import React from "react";

import {
  Context,
  fetchClasses,
  fetchKlassIdsWithActiveLearningMaterials,
} from "../../../teacherStore";
import TeachingClassList from "../../../templates/teacher/TeachingClassList";
import { parseQueryParams } from "../../../libs/Util";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const classListInParams = parseQueryParams()["classList"];
  const isActiveLearningParam =
    parseQueryParams()["isActiveLearning"] === "true";
  const selectedClassIds: number[] = React.useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  React.useEffect(() => {
    dispatch(fetchClasses());
    dispatch(fetchKlassIdsWithActiveLearningMaterials());
  }, [dispatch]);

  return (
    <TeachingClassList
      classes={
        isActiveLearningParam
          ? state.klass_ids_with_active_learning_materials
          : state.classes
      }
      selectedClassIds={selectedClassIds}
    />
  );
};
